// extracted by mini-css-extract-plugin
export var container = "_5c-1";
export var editor = "_5c-2";
export var resizable = "_5c-3";
export var wrapper = "_5c-0";